import { darkModalOutline } from "Styles/darkModal";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;

  gap: 40px;
  padding: 40px 0;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  ${media.greaterThan("medium")`
    width: 1024px;
    margin: 0 auto;
    max-width: 1300px;
    padding: 20px 0;
  `};

  .rec-arrow {
    background-color: transparent !important;
    box-shadow: none;
  }

  .rec-dot {
    background-color: ${({ theme }) => theme.colors.neutral.white};
  }

  .rec-dot_active {
    background-color: ${({ theme }) => theme.colors.primary.green};
    box-shadow: none;
  }
`;

export const ActiveText = styled.h2`
  ${({ theme }) => theme.font.heading.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => theme.colors.neutral.white};

  padding-left: 57px;

  ${media.lessThan("medium")`
    padding-left: 0px;
  `}
`;

export const ActiveProduction = styled.div`
  display: flex;
  justify-content: space-between;
  grid-template-rows: 1fr;
  gap: 20px;

  width: 100%;
`;

export const ActiveImage = styled.div`
  position: relative;
  width: 100%;

  img {
    width: 100%;
    height: 404px;
    object-fit: cover;
    cursor: pointer;
  }

  ${media.lessThan("medium")`
    display: ${({ show }) => (show ? "block" : "none")};
  `}
`;

export const ActiveInfos = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;

  padding: 20px;
  height: 100%;
  width: 315px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  background-color: #466025e5;

  ${media.lessThan("medium")`
    width: 100%;
  `}
`;

export const PremiereDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  p {
    text-align: center;
    ${({ theme }) => theme.font.body.sm};
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }

  span {
    font-size: 12px;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Productions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 50px;
`;

export const Production = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  cursor: pointer;

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    margin-bottom: 10px;
  }

  p {
    ${({ theme }) => theme.font.body.md};
    font-weight: ${({ theme }) => theme.font.weight.regular};
  }

  h3 {
    ${({ theme }) => theme.font.body.lg};
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }
`;

export const Background = styled.div`
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0);
  z-index: 10;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `}
`;

export const VideoModalBackground = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.8);
  z-index: 20;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideoModal = styled.div`
  background-color: rgb(0, 0, 0);
  z-index: 20;

  width: 60%;
  height: 70%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  padding: 20px;

  iframe {
    width: 100%;
    height: 100%;
  }

  ${media.lessThan("medium")`
    height: fit-content;
    `}
`;

export const Modal = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100%;

  background-color: rgb(0, 0, 0);
  z-index: 20;

  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  padding: 100px 20vw;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 120px 20px;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    position: fixed;
  `}

  /* Contorno: sem ele o modal se funde ao fundo preto da pagina. */
  ${darkModalOutline}
`;

export const GetBack = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  cursor: pointer;

  span {
    width: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  h3 {
    ${({ theme }) => theme.font.heading.md};
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }
`;

export const MainContent = styled.div`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: 1fr 1fr;

  img {
    width: 100%;
    object-fit: cover;
  }

  ${media.lessThan("1200px")`
    display: flex;
    flex-direction: column;
    gap: 40px;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  height: calc(100% - 36px);
  max-height: calc(100% - 36px);

  min-height: 300px;

  overflow: auto;

  background-color: rgb(30 30 30);
  padding: 15px;
`;

export const HtmlDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    cursor: pointer;
    font-weight: 700;
  }
`;

export const Images = styled.div`
  min-height: 350px;
`;

export const Image = styled.img`
  cursor: pointer;
`;

export const Details = styled.div`
  padding: 30px 0px;

  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  align-items: center;
  text-align: center;

  button {
    max-width: 300px;
  }

  p {
    font-size: 14px;
  }

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;

    button {
      max-width: 100%;
    } 
  `}
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h4 {
    ${({ theme }) => theme.font.body.md};
    font-weight: ${({ theme }) => theme.font.weight.regular};
  }

  p {
    color: ${({ theme }) => theme.colors.neutral.white};
    ${({ theme }) => theme.font.body.sm};
    font-weight: ${({ theme }) => theme.font.weight.regular};
  }
`;

export const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
`;
